<template lang="pug">
  .project-files-container
    ProjectFileFrame(v-for="(fileData, index) in filesData" @changeFileSelection="changeFileSelection"
      @clickMenu="clickMenu" :key="fileData.id" :fileData="fileData" :orientationType="orientationType"
      :selected="fileData.selected" class="project-file" :fileIndex="index"
      @fileDragStart="fileDragStart" @fileDrag="fileDrag" @viewImage="setViewedImage")
    BasePopup(
        :type="viewedImage.info.type"
        v-if="viewedImageIndex !== null"
        :src="viewedImage.file.url"
        :hasPrev="hasPrev"
        :hasNext="hasNext"
        @prev="setPrev"
        @next="setNext"
        @close="viewedImageIndex = null"
      )
</template>

<script>
import ProjectFileFrame from '@/components/project/ProjectFileFrame.vue';
import BasePopup from '@/components/BasePopup.vue';
import fileTypes from '@/utils/fileTypes';

export default {
  name: 'ProjectFilesContainer',
  components: { ProjectFileFrame, BasePopup },
  props: {
    filesData: {
      type: Array,
      default: () => [],
    },
    orientationType: {
      type: String,
      default: 'square',
    },
  },
  data() {
    return {
      viewedImageIndex: null,
    };
  },
  computed: {
    images() {
      return this.filesData
        .filter((i) => fileTypes[i.file.extension]?.hasPreview)
        .map(f => ({
          ...f,
          info: fileTypes[f.file.extension] ?? {},
        }));
    },
    viewedImage() { return this.images[this.viewedImageIndex]; },
    hasNext() { return this.viewedImageIndex < this.images.length - 1; },
    hasPrev() { return this.viewedImageIndex > 0; },
  },
  methods: {
    changeFileSelection(fileDataId) {
      this.$emit('changeFileSelection', fileDataId);
    },
    clickMenu(action, fileData) {
      this.$emit('clickMenu', action, fileData);
    },
    fileDragStart(e, fileData) {
      this.$emit('fileDragStart', e, fileData);
    },
    fileDrag(e) {
      this.$emit('fileDrag', e);
    },
    setPrev() {
      if (this.hasPrev) {
        this.viewedImageIndex -= 1;
      }
    },
    setNext() {
      if (this.hasNext) {
        this.viewedImageIndex += 1;
      }
    },
    setViewedImage(file) {
      this.viewedImageIndex = this.images.findIndex((i) => i.id === file.id);
    },
  },
};
</script>

<style scoped lang="scss">
  .project-files-container {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 15px;
  }
</style>
